export enum AuthRoutes {
    login = `/auth/local`,
    register = `/auth/local/register`,
    forgotPassword = `/auth/forgot-password`,
    resetPassword = `/auth/reset-password`,
    sendEmailConfirmation = `/auth/send-email-confirmation`,
    me = `/users/me`
}
